import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Globe, GlobeRegular } from "../components/styled/AllImages";

const ChangeButton = ({ bg, color }) => {
  const { i18n } = useTranslation();
  const [isEnglishSelected, setIsEnglishSelected] = useState(
    Cookies.get("lang") === "en" ? true : false
  );

  const changeLanguageAndDirection = (lng, dir) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = dir;
    document.body.classList.toggle("rtl", dir === "rtl");
    Cookies.set("lang", lng, { expires: 60, path: "/" });
    Cookies.set("dir", dir, { expires: 60, path: "/" });
  };

  const handleLanguageChange = () => {
    const newLang = isEnglishSelected ? "ar" : "en";
    const newDir = isEnglishSelected ? "rtl" : "ltr";
    changeLanguageAndDirection(newLang, newDir);
    setIsEnglishSelected(!isEnglishSelected);
  };

  useEffect(() => {
    const savedLang = Cookies.get("lang") || "ar";
    const savedDir = Cookies.get("dir") || "rtl";

    changeLanguageAndDirection(savedLang, savedDir);
  }, []);

  return (
    <ButtonBox bg={bg} color={color} onClick={handleLanguageChange}>
      <span className="change-Btn">
        <GlobeRegular className="icon" alt={isEnglishSelected ? "Arabic" : "USA"} />
        <span
          style={{
            fontFamily: !isEnglishSelected
              ? "var(--regular)"
              : "var(--arRegular)",
          }}
          className="lang-text"
        >
          {isEnglishSelected ? "العربية" : "English"}
        </span>
      </span>
    </ButtonBox>
  );
};

const ButtonBox = styled.div`
  padding: 0;
  cursor: pointer;
  z-index: 1;

  .change-Btn {
    background: ${({ bg }) => (bg ? bg : "var(--themeColorSecondary)")};
    border: none;
    border-radius: 6px;
    color: ${({ color }) => (color ? color : "var(--white)")};
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 44px;
    padding: 0px 20px;
    position: relative;

    svg {
      width: 22px;
      height: auto;
      margin: 0 6px;
    }

    span {
      padding-bottom: 0;
      font-family: var(--arBoldSans);
    }
  }

  .icon {
    cursor: pointer;
    z-index: 1;
  }

  @media (max-width: 1199px) {
    /* .lang-text {
      display: none
    }  */
  }
  @media (max-width: 470px) {
    .change-Btn {
      padding: 0 10px !important;
    }
    .icon {
      display: none;
    }
  }
`;

export default ChangeButton;
